import apiClient from "./apiClient";

// invoices
export const getInvoiceReport = (
  noLimit = true, 
  invoiceDateStart = "", 
  invoiceDateEnd = "",
  dueDateStart = "",
  dueDateEnd = "",
  petOwnerId = "",
  historyEntryUserId = "",
  procedureId = ""
) => apiClient
  .get("/reports/invoice", { params: { noLimit, invoiceDateStart, invoiceDateEnd, dueDateStart, dueDateEnd, petOwnerId, historyEntryUserId, procedureId } })
  .then(res => res);

export const getMedicalHistoryReport = (
  noLimit = true, 
  dateStart = "", 
  dateEnd = "",
  petId = "",
  petOwnerId = "",
  historyEntryUserId = "", 
  procedureId = ""
) => apiClient
  .get("/reports/medical-history", { params: { noLimit, dateStart, dateEnd, petId, petOwnerId, historyEntryUserId, procedureId } })
  .then(res => res);

export const getAppointmentReport = (
  noLimit = true, 
  dateStart = "", 
  dateEnd = "",
  petId = "",
  userId = "",
  statusId = "",
  remarks = ""
) => apiClient
  .get("/reports/appointment", { params: { noLimit, dateStart, dateEnd, petId, userId, statusId, remarks } })
  .then(res => res);